/**
 * Gets the current biathlon year != normal year. Shifted by 5 months
 * @returns the current biathlon year starting from May to May
 */
export function getCurrentBiathlonYear(): string {
  const currentDate = new Date();
  currentDate.setMonth(currentDate.getMonth() - 3);
  return `${currentDate.getFullYear()}/${currentDate.getFullYear() + 1 - 2000}`;
}
